// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftMenu[data-v-a268980a] {\n  width: 220px;\n  height: 100%;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
